/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Row, Col, Button, Collapse, Alert, Space, Typography } from "antd";
import { BrowserView, MobileView } from "react-device-detect";
import { useHistory } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import * as actions from "./actions";
import RenderTime from "./RenderTime";
import { changeFromDate, clearCurrentPatient, toggleItem } from "../Booking/actions";
import { clearPatients } from "../Session/actions";
import { isEmpty } from "lodash";
import DatePicker from "./DatePicker";
import { accountBaseUrl } from "../../helpers/account";
import {
  getAvailabilityLoadingState,
  getAvailabilityRangeLoadingState,
} from "./reducers";
import {
  getFromDate,
  hasTimeSelectedForRequests,
  getAvailabilityRequests,
} from "../Booking/reducers";
import { fetchCurrentLocationRequest } from "../Location/actions";
import { getCurrentLocation } from "../Location/reducers";
import { fetchPracticeProfessionalAppointmentReasonsRequest } from "../Service/actions";
import moment from "moment";
import ContentContainer from "../../components/ContentContainer";
import { ArrowLeftOutlined, InfoCircleOutlined } from "@ant-design/icons";

const uiFormat = "DD/MM/YYYY";
const hGutter = {
  xs: 16,
  md: 32,
  lg: 32,
  xl: 32,
};

const Availability = ({
  fromDate,
  availabilityLoadingState,
  fetchProfessionalAvailabilityRequest,
  match,
  changeFromDate,
  isTimeSlotSelected,
  availabilityRequests,
  fetchCurrentLocationRequest,
  fetchPracticeProfessionalAppointmentReasonsRequest,
  fetchAvailabilityBetweenRangeRequest,
  currentPractice,
  clearCurrentPatient,
  clearPatients,
  availabilityRangeLoadingState,
}) => {
  const { params } = match;
  const { locationId: practiceId, practitionerId, reasonId } = params;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    clearCurrentPatient();
    clearPatients();

    if (practitionerId && reasonId && isEmpty(availabilityRequests)) {
      dispatch(toggleItem({
        reasonId: Number(reasonId),
        practitionerId: Number(practitionerId),
      }))

      dispatch(
        fetchAvailabilityBetweenRangeRequest(
          practiceId,
          moment().clone().subtract(1, "days").format(uiFormat),
          moment().clone().add(6, "weeks").format(uiFormat),
        )
      )
    }
    fetchProfessionalAvailabilityRequest(practiceId);

    fetchCurrentLocationRequest(practiceId);
  }, []);

  const handleDateChange = React.useCallback((id, date) => {
    changeFromDate(id, date);
  }, []);

  const handleGoBack = React.useCallback(() => {
    if (history.length > 1) {
      return history.goBack()
    } else if (practitionerId) {
      return history.push(
        `${accountBaseUrl}/locations/${practiceId}/practitioner/${practitionerId}/reasons`
      );
    } else {
      return history.push(
        `${accountBaseUrl}/locations/${practiceId}/reasons`
      );
    }
  }, [])

  return (
    <>
      <ContentContainer
        showNext={false}
        step={3}
        themeColor={currentPractice?.themeColor}
        stepPercentage={60}
        pageTitle="Select suitable date and time"
        backButton={
          <Button onClick={() => handleGoBack()} shape="round" type="text" icon={<ArrowLeftOutlined />} />
        }
      >
        <BrowserView>
          <Row gutter={hGutter}>
            <Col flex="350px">
              <DatePicker
                fromDate={fromDate}
                {...currentPractice}
                changeFromDate={changeFromDate}
                practiceId={practiceId}
                fetchAvailabilityBetweenRangeRequest={
                  fetchAvailabilityBetweenRangeRequest
                }
                availabilityRangeLoadingState={availabilityRangeLoadingState}
              />
            </Col>

            <Col flex="1">
              <RenderTime
                practiceId={practiceId}
                date={fromDate}
                themeColor={currentPractice?.themeColor}
              />
              {currentPractice?.bookingMessageContent && (
                <div style={{ marginTop: 24 }}>
                  <Alert
                    icon={<InfoCircleOutlined style={{ color: "black" }} />}
                    style={{
                      background: "#fafafa",
                      border: "1px solid #d9d9d9",
                    }}
                    showIcon
                    message={
                      <Typography.Text>
                        {currentPractice?.bookingMessageTitle}
                      </Typography.Text>
                    }
                    description={currentPractice?.bookingMessageContent}
                    closable={currentPractice?.allowDismissableBookingMessage}
                  />
                </div>
              )}
            </Col>
          </Row>
        </BrowserView>

        <MobileView>
          <Space direction="vertical">
            <Collapse size="small" defaultActiveKey={["Date", "Time"]}>
              <Collapse.Panel header="Pick date" key="Date">
                <DatePicker
                  {...currentPractice}
                  changeFromDate={handleDateChange}
                  practiceId={practiceId}
                  fetchAvailabilityBetweenRangeRequest={
                    fetchAvailabilityBetweenRangeRequest
                  }
                  availabilityRangeLoadingState={availabilityRangeLoadingState}
                />
              </Collapse.Panel>
              <Collapse.Panel header="Select time" key="Time">
                <RenderTime
                  practiceId={practiceId}
                  date={fromDate}
                  themeColor={currentPractice?.themeColor}
                />
              </Collapse.Panel>
            </Collapse>
            {currentPractice?.bookingMessageContent && (
              <div style={{ marginTop: 24 }}>
                <Alert
                  icon={<InfoCircleOutlined style={{ color: "black" }} />}
                  style={{
                    background: "#fafafa",
                    border: "1px solid #d9d9d9",
                  }}
                  showIcon
                  message={
                    <Typography.Text>
                      {currentPractice?.bookingMessageTitle}
                    </Typography.Text>
                  }
                  description={currentPractice?.bookingMessageContent}
                  closable={currentPractice?.allowDismissableBookingMessage}
                />
              </div>
            )}
          </Space>
        </MobileView>
      </ContentContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  availabilityLoadingState: getAvailabilityLoadingState(state.availability),
  availabilityRangeLoadingState: getAvailabilityRangeLoadingState(
    state.availability
  ),
  isTimeSlotSelected: hasTimeSelectedForRequests(state.booking),
  fromDate: getFromDate(state.booking),
  availabilityRequests: getAvailabilityRequests(state.booking),
  currentPractice: getCurrentLocation(state.locations),
});

export default connect(mapStateToProps, {
  ...actions,
  changeFromDate,
  fetchCurrentLocationRequest,
  fetchPracticeProfessionalAppointmentReasonsRequest,
  clearCurrentPatient,
  clearPatients,
})(Availability);
